module.exports = __webpack_public_path__ + "img/Central African Republic.23335001.svg";